import { RefObject, useEffect } from 'react';

const useOutsideClick = (ref: RefObject<HTMLElement> | undefined, callback: () => void) => {
  const handleClick = (event: MouseEvent) => {
    if (ref?.current && !ref?.current?.contains(event.target as Node)) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  });
};

export default useOutsideClick;
